// Modal Backdrop
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;

  [data-theme='dark'] & {
    background: rgba(0, 0, 0, 0.7);
  }
}

.modal {
  width: 100%;
  max-width: 480px;
  background: var(--color-surface-primary);
  border-radius: map.get($radius, 'lg');
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 40px);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: map.get($spacing-scale, 'lg') map.get($spacing-scale, 'xl');
  border-bottom: 1px solid var(--color-grey-soft);
}

.title {
  @include heading-4;
  margin: 0;
  color: var(--color-text-primary);
}

.closeButton {
  flex-shrink: 0;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding: map.get($spacing-scale, 'xl');
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'lg');
}

.description {
  @include body-small-regular;
  color: var(--color-text-secondary);
  margin: 0;
}

.field {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'sm');
}

.fieldLabel {
  @include body-small-medium;
  color: var(--color-text-secondary);
  margin: 0;
}

.helper {
  @include metadata-regular;
  color: var(--color-text-tertiary);
  margin: 0;
}

.error {
  @include body-small-medium;
  color: var(--color-semantic-danger);
  margin: 0;
}

.input {
  background-color: var(--color-surface-primary);
  border: 1px solid var(--color-grey-neutral);

  &:focus-within {
    border-color: var(--color-primary-base);
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: map.get($spacing-scale, 'md');
  padding: map.get($spacing-scale, 'lg') map.get($spacing-scale, 'xl');
  border-top: 1px solid var(--color-grey-soft);
}

@media (max-width: $breakpoint-md) {
  .modal {
    max-width: 100%;
    border-radius: map.get($radius, 'md');
  }

  .header,
  .content,
  .footer {
    padding: map.get($spacing-scale, 'md');
  }
}
